// extracted by mini-css-extract-plugin
export var backdropBlur = "_e0-0";
export var contentCard = "_e0-5";
export var frame = "_e0-2";
export var image = "_e0-4";
export var imagePane = "_e0-3";
export var modal = "_e0-1";